import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { RoutePartCMRSignatureAgents } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { DocumentParentObjectDto } from '@shared/src/dtos/documentaryreview/DocumentParentObjectDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RouteCMRAgentPhaseExpandDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandDto';
import { RoutePartCMRDto } from '@shared/src/dtos/route/cmr/RoutePartCMRDto';
import { DocumentParentTypes } from '@shared/src/enums/DocumentParentTypes';
import { AlertService, HString, SharedExternalCMRAgentPhaseComponent } from '@shared/src/public-api';
import { SharedExternalCMRAgentPhaseSignActionsComponent } from '../signactions/shared.external.cmr.agent.phase.signactions.component';

@Component({
    selector: 'shared-external-cmr-agent-phase-ecmrs-digitaldocument',
    templateUrl: './shared.external.cmr.agent.phase.ecmrs.digitaldocument.component.html',
    styleUrls: ['./shared.external.cmr.agent.phase.ecmrs.digitaldocument.component.scss']
})
export class SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent implements OnInit {


    public sender: RouteCMRAgents = RouteCMRAgents.sender;
    public driver: RouteCMRAgents = RouteCMRAgents.driver;
    public consignee: RouteCMRAgents = RouteCMRAgents.consignee;
    
    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __phaseUUID: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.__phaseUUID === value)
            return;
        this.__phaseUUID = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.__phaseUUID;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    
    @Input()
    public doAction: boolean = false;

    public value: RouteCMRAgentPhaseExpandDto;
    loadData() {
        if (!HString.isNullOrNullString(this.phaseUUID) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentPhaseByUUID(this.phaseUUID, this.agent).subscribe(data => { 
                this.wellcome(data);
            });
        }
    }

    public parentObject: DocumentParentObjectDto;
    public optionSelected: string = "";
    public onClickOption(option: OptionDto) {
        this.optionSelected = option ? option.optionId : "";
        if(this.optionSelected == "GENERAL")
            this.parentObject = this.value != null ? DocumentParentObjectDto.build(DocumentParentTypes.Phase, 0, this.value.phaseId, 0, 0, 0) : null;
        else if(this.getRoutePartCMRId() > 0)
            this.parentObject = this.value != null ? DocumentParentObjectDto.build(DocumentParentTypes.RoutePartCMR, 0, 0, 0, this.getRoutePartCMRId(), 0) : null;
    }

    public options: OptionsStripDto = new OptionsStripDto();
    public wellcome(value: RouteCMRAgentPhaseExpandDto) {

        this.value = value;
        this.options = new OptionsStripDto();

        if (this.value != null && this.value.cmrs != null && this.value.cmrs.length > 0){
            if(this.value.cmrs.length > 1){
                this.options.add(OptionDto.build("GENERAL", "General", "General", "", 1, -1, 1, true, false));
                let i = 2;
                this.value.cmrs.forEach(x => {
                    if (x && x.routePartCMRId) {
                        this.options.add(OptionDto.build(x.routePartCMRId.toString(), this.formatCMRKey(x.routePartCMRKey), x.routePartCMRKey, "", i, -1, i > 3 ? -1 : 1, false, false));
                        i++;
                    }
                });
                this.onClickOption(this.options.getActualSelected());
            }else{
                this.optionSelected = this.getRoutePartCMRId() + "";
            }
        }else{
            this.optionSelected = "";
        }

    }

    getRoutePartCMRId(): number {
        if (this.value != null && this.value.cmrs != null && this.value.cmrs.length > 0){
            if(this.value.cmrs.length > 1){
                if (HString.isNullOrNullString(this.optionSelected) || this.optionSelected == "0")
                    return 0;
                if (this.optionSelected == "GENERAL")
                    return 0;

                return this.getToNumber(this.optionSelected);
                
            }else{
                return this.value.cmrs[0].routePartCMRId;
            }
        }
        return 0;
    }

    public getToNumber(input: string): number {
        return parseInt(input);
    }

    public formatCMRKey(key: string): string {
        return key.replace(/0+/g, '..');
    }

    getOptionId(): number {
        if (!HString.isNullOrNullString(this.optionSelected)) {
            if (this.optionSelected == "GENERAL")
                return -1;
            return Number(this.optionSelected);
        }
        return 0;
    }
     
    public getCount():number{
        if(this.value == null || this.value.cmrs == null)
            return 0;
        return this.value.cmrs.length;
    }

    onDocumentValueChanged(){
        
    }

    public getResourcePhase(): string{
        if(!this.doAction){
            if(this.value == null || this.value.isLoad)
                return 'SHARED.EXTERNAL.CMR.PHASE.ISLOAD';
            return 'SHARED.EXTERNAL.CMR.PHASE.ISUNLOAD';
        }else{
            if(this.value == null || this.value.isLoad)
                return 'SHARED.EXTERNAL.CMR.ACTIONS.UNLOADPHASE.CAPTION';
            return 'SHARED.EXTERNAL.CMR.ACTIONS.LOADPHASE.CAPTION';
        }
    }
    
    public getResourceGoToSignature(a: RouteCMRAgents, value: boolean): string{
         if(value)
            return 'SHARED.EXTERNAL.CMR.PHASE.SHOWSIGNATURE';
        
        if(a == this.agent)
            return 'SHARED.EXTERNAL.CMR.PHASE.SIGN';
        return 'SHARED.EXTERNAL.CMR.PHASE.HAVETHEMSIGN';
    }

    @ViewChild(SharedExternalCMRAgentPhaseComponent) phaseConsigneeComponent: SharedExternalCMRAgentPhaseComponent;
    @ViewChild(SharedExternalCMRAgentPhaseSignActionsComponent) signActionsComponent: SharedExternalCMRAgentPhaseSignActionsComponent;
   
    public showPhaseConsignee: boolean;
    
    public collapse(): boolean {
        // Si estem informant d'un problema o comentant, tornem a la firma
        if (this.signingPanel != null) {
            this.signingPanel = null;
            this.signActionsComponent?.loadData();
            return true;
        }
        if (this.showPhaseConsignee) {
            if(this.phaseConsigneeComponent?.collapse())
                return true;
            this.showPhaseConsignee = false;
            return true;
        }
        return false;
    }

    public signingAgent: RoutePartCMRSignatureAgents = null;
    public RoutePartCMRSignatureAgents = RoutePartCMRSignatureAgents;

    toggleSigning(agent: RoutePartCMRSignatureAgents) {
        if(this.doAction && agent == RoutePartCMRSignatureAgents.consignee && !this.value.isSignedConsignee){
            //Hem de mostrar el component de phase
            this.showPhaseConsignee = true;
        }else{
            if (this.signingAgent === agent)
                this.signingAgent = null;
            else
                this.signingAgent = agent;
        }
    }

    closeSigning() {
        this.signingAgent = null;
        this.signingPanel = null;
    }

    /**
     * Formulari obert a pantalla completa des de la firma: 'INCIDENT' (informar d'un problema), 'COMMENT', 'STANDSTILL' (estic parat) o null.
     * Es tanca amb el botó enrere de la barra (collapse) o en guardar/cancel·lar
     */
    public signingPanel: string = null;
    public openSigningPanel(panel: string): void {
        this.signingPanel = panel;
    }

    // El missatge de confirmació ja el retorna el backend
    public onSigningPanelDone(saved: boolean): void {
        this.collapse();
    }

    onSigned() {
        this.loadData();
    }

    getClassIcon(value: boolean){
        if(value)
            return 'fa-check-square-o';
        return 'fa-square-o';
    }
    
    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
